import type { SVGProps } from "react";
const SvgBellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    fontSize="1rem"
    {...props}
  >
    <path
      stroke="#D4183D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M15.179 8.06a5 5 0 0 0-10 0c0 5.834-2.5 7.5-2.5 7.5h15s-2.5-1.666-2.5-7.5M13.107 16.129a3.6 3.6 0 0 1-1.24 1.383 3.1 3.1 0 0 1-1.69.506 3.1 3.1 0 0 1-1.69-.506A3.6 3.6 0 0 1 7.25 16.13M2.68 5.765c-.036-.19-.021-.424.043-.68.063-.255.174-.522.32-.775s.322-.483.511-.665c.19-.183.385-.313.567-.377M15.88 3.267c.182.064.377.194.566.377.19.183.366.412.512.665s.256.52.32.775c.064.256.079.49.043.68"
    />
    <path
      stroke="#D4183D"
      strokeLinecap="round"
      strokeWidth={1.333}
      d="M10.267 1.981v.675"
    />
  </svg>
);
export default SvgBellIcon;
